import React, { FC, ReactElement, useState } from 'react';
import cns from 'classnames';
import { useSelector } from 'react-redux';
import ModalVideo from 'react-modal-video';
import Icon from '../../../Icon';
import './About.sass';
import { getContentDataAbout } from '../../../../stores/reducers/userData';
import {internalizationState} from '../../../../stores/reducers/sections';
import ReactHtmlParser from 'react-html-parser';
import localeFieldResolver from '../../.././../helpers/locale-field-finder';

interface Props {
  className?: string | Array<string>;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName?: string;
  sectionId: string;
}

const About: FC<Props> = ({ className, bgSettings, sectionName, sectionId }): ReactElement => {
  const { backendURL, confImage, confYoutube, count, ...localeData } = useSelector(getContentDataAbout);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const { activeLangState } = useSelector(internalizationState);

  return (
    <>
      {confYoutube && (
        <ModalVideo
          channel="youtube"
          isOpen={isVideoOpen}
          videoId={confYoutube.trim()}
          onClose={() => setIsVideoOpen(false)}
        />
      )}
      <section
        className={cns('inner-section', bgSettings && bgSettings.isDark && 'inner-section--dark-bg', className)}
        style={{ backgroundColor: bgSettings && bgSettings.color }}
      >
        <div className="container" id={sectionId}>
          <div className="about-inner">
            <div className="section-title">{sectionName}</div>
            <div className="about-wrapp">
              <div className="about-video">
                <div className="about-video__img">
                  {confImage && <img src={`${backendURL}${confImage}`} alt="" />}
                </div>
                {confYoutube && (
                  <div className="about-video__play">
                    <button className="play-video-btn" type="button" onClick={() => setIsVideoOpen(true)}>
                      <Icon name="play" />
                    </button>
                  </div>
                )}
              </div>
              <div className="about-info">
                <ul className="about-info-list f-heading">
                  {count?.map((c: any, ind: any) => (
                    <li key={ind}>
                      <strong>{localeFieldResolver(c, 'text', activeLangState)}</strong>
                      <span>{localeFieldResolver(c, 'value', activeLangState)}</span>
                    </li>
                  ))}
                </ul>
                <p className="user-fs-text__sm text-light">{ReactHtmlParser(localeFieldResolver(localeData, 'confInfoAdditional', activeLangState) as string)}</p>
                <div className="inserted-html">
                  {ReactHtmlParser(localeFieldResolver(localeData, 'confInfo', activeLangState) as string)}
                </div>
                {/* {(localeFieldResolver(localeData, 'confInfo', activeLangState) as string)?.split('\n').map((text: string, ind: number) => (
                  <p key={ind} className="user-fs-text">
                    {ReactHtmlParser(text)}
                  </p>
                ))} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
